import React from 'react';

const RequisitesUpdate = () => {
    return (
        <div>
            
        </div>
    );
};

export default RequisitesUpdate;